import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sigma",
  "use": "sigma-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sigma\"><path d=\"M18 6H8.83l6 6-6 6H18v2H6v-2l6-6-6-6V4h12v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol